/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Full_TableInputs */

const th_full_table = /** @type {(inputs: Full_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตารางเต็ม →`)
};

const en_full_table = /** @type {(inputs: Full_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full table →`)
};

const ja_full_table = /** @type {(inputs: Full_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`順位表全体 →`)
};

const zh_full_table = /** @type {(inputs: Full_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完整积分榜 →`)
};

const es_full_table = /** @type {(inputs: Full_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabla completa →`)
};

const pt_full_table = /** @type {(inputs: Full_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabela completa →`)
};

const id_full_table = /** @type {(inputs: Full_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klasemen lengkap →`)
};

const fr_full_table = /** @type {(inputs: Full_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classement complet →`)
};

const tl_full_table = /** @type {(inputs: Full_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buong talaan →`)
};

const vi_full_table = /** @type {(inputs: Full_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bảng đầy đủ →`)
};

const ko_full_table = /** @type {(inputs: Full_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전체 순위표 →`)
};

const de_full_table = /** @type {(inputs: Full_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganze Tabelle →`)
};

const ru_full_table = /** @type {(inputs: Full_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полная таблица →`)
};

const tr_full_table = /** @type {(inputs: Full_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tam puan durumu →`)
};

const it_full_table = /** @type {(inputs: Full_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classifica completa →`)
};

const pl_full_table = /** @type {(inputs: Full_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pełna tabela →`)
};

const uk_full_table = /** @type {(inputs: Full_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повна таблиця →`)
};

const hi_full_table = /** @type {(inputs: Full_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूरी तालिका →`)
};

const ar_full_table = /** @type {(inputs: Full_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الجدول الكامل ←`)
};

const ms_full_table = /** @type {(inputs: Full_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadual penuh →`)
};

const bn_full_table = /** @type {(inputs: Full_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পূর্ণ তালিকা →`)
};

const zh_tw2_full_table = /** @type {(inputs: Full_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完整積分榜 →`)
};

const zh_hk2_full_table = /** @type {(inputs: Full_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完整積分榜 →`)
};

const ur_full_table = /** @type {(inputs: Full_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مکمل فہرست ←`)
};

const fa_full_table = /** @type {(inputs: Full_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جدول کامل ←`)
};

const sw_full_table = /** @type {(inputs: Full_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jedwali kamili →`)
};

const nl_full_table = /** @type {(inputs: Full_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volledige stand →`)
};

/**
* | output |
* | --- |
* | "Full table →" |
*
* @param {Full_TableInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const full_table = /** @type {((inputs?: Full_TableInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Full_TableInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_full_table(inputs)
	if (locale === "ja") return ja_full_table(inputs)
	if (locale === "zh") return zh_full_table(inputs)
	if (locale === "es") return es_full_table(inputs)
	if (locale === "pt") return pt_full_table(inputs)
	if (locale === "id") return id_full_table(inputs)
	if (locale === "fr") return fr_full_table(inputs)
	if (locale === "tl") return tl_full_table(inputs)
	if (locale === "vi") return vi_full_table(inputs)
	if (locale === "ko") return ko_full_table(inputs)
	if (locale === "de") return de_full_table(inputs)
	if (locale === "ru") return ru_full_table(inputs)
	if (locale === "tr") return tr_full_table(inputs)
	if (locale === "it") return it_full_table(inputs)
	if (locale === "pl") return pl_full_table(inputs)
	if (locale === "uk") return uk_full_table(inputs)
	if (locale === "hi") return hi_full_table(inputs)
	if (locale === "ar") return ar_full_table(inputs)
	if (locale === "ms") return ms_full_table(inputs)
	if (locale === "bn") return bn_full_table(inputs)
	if (locale === "zh-TW") return zh_tw2_full_table(inputs)
	if (locale === "zh-HK") return zh_hk2_full_table(inputs)
	if (locale === "ur") return ur_full_table(inputs)
	if (locale === "fa") return fa_full_table(inputs)
	if (locale === "sw") return sw_full_table(inputs)
	if (locale === "nl") return nl_full_table(inputs)
	return en_full_table(inputs)
});